import construction from "../../assets/construction.png";
import estimate from "../../assets/estimate.png";
import interior from "../../assets/interior.png";
import fabrication from "../../assets/fabrication.png";
import airconditioning from "../../assets/airconditioning.png";
import trucking from "../../assets/trucking.png";

import paintbrush from "../../assets/paintbrush.png";

export const cardDetails = [
  { icon: estimate, title: "Pre-construction Planning" },
  { icon: construction, title: "Construction" },
  { icon: fabrication, title: "Equipment Fabrication" },
  { icon: trucking, title: "Tracking Hauling Services" },
  { icon: airconditioning, title: "Airconditioning and Refrigiration" },
  { icon: paintbrush, title: "Painting Services" },
];
